import type { ReactNode } from 'react';

interface BandProps {
  /** Anchor id for in-page links. */
  id?: string;
  /** `wash-down` fades from the wash into the page, `wash-up` the reverse. */
  wash?: 'wash-down' | 'wash-up' | 'wash';
  /** Extra classes on the bordered column, e.g. `text-center`. */
  className?: string;
  children: ReactNode;
}

/**
 * One full-width editorial section: the outer container, the bordered column
 * that carries the page's two vertical hairlines, and a bottom rule. Children
 * lay out their own bands with `band`, `band-prose` and `rule-dashed`.
 *
 * It relies on `SiteLayout`'s full-width `main`.
 */
export const Band = ({ id, wash, className = '', children }: BandProps) => (
  <section id={id} className="border-b border-rule">
    <div className={`page-wrap ${wash === 'wash' ? 'bg-wash' : (wash ?? '')}`}>
      <div className={`page-col ${className}`}>{children}</div>
    </div>
  </section>
);
